/* Joffzart: live Loox text presentation and native visual collections navigation. */
(() => {
  if (!customElements.get('joffz-review-rail')) customElements.define('joffz-review-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.track = this.querySelector('[data-review-track]');
      this.source = this.querySelector('[data-review-source]');
      this.prev = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      this.signature = '';
      this.attempt = 0;
      const opts = {signal:this.abort.signal};
      this.prev.addEventListener('click',()=>this.move(-1),opts);
      this.next.addEventListener('click',()=>this.move(1),opts);
      this.track.addEventListener('scroll',()=>this.navigation(),{...opts,passive:true});
      this.querySelector('[data-review-all]').addEventListener('click',()=>{
        const reviews = document.querySelector('#JP2-all-product-reviews');
        if (reviews) { reviews.open=true; reviews.scrollIntoView({behavior:this.motion(),block:'start'}); return; }
        const floating = document.querySelector('#loox-floating-widget-btn');
        if (floating) { floating.click(); return; }
        this.classList.remove('is-ready'); this.source.removeAttribute('aria-hidden');
      },opts);
      this.visibility = new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&!this.classList.contains('is-ready')){this.attempt=0;this.connectSource();}},{rootMargin:'600px'});
      this.visibility.observe(this);
      customElements.whenDefined('loox-dynamic-carousel-widget').then(()=>{if(this.abort){this.attempt=0;this.connectSource();}});
      this.connectSource();
    }
    motion() {return matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';}
    connectSource() {
      clearTimeout(this.timer);
      if(!this.abort||!this.isConnected)return;
      const widget = this.source.querySelector('loox-dynamic-carousel-widget');
      const shadow = widget?.shadowRoot;
      if (shadow) {
        if (this.shadow !== shadow) {
          this.observer?.disconnect(); this.shadow=shadow;
          this.observer=new MutationObserver(()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.render());});
          this.observer.observe(shadow,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','title','hidden']});
        }
        this.render();
      }
      if (!this.classList.contains('is-ready') && ++this.attempt < 40) this.timer=setTimeout(()=>this.connectSource(),500);
    }
    render() {
      if (!this.shadow) return;
      const records = new Map();
      for (const row of this.shadow.querySelectorAll('.dynamic-carousel-text-swiper-content')) {
        const name=row.querySelector('.reviewer-name')?.textContent.trim();
        const text=row.querySelector('.review-text')?.textContent.trim();
        const rating=Number(row.querySelector('.review-rating')?.getAttribute('title')?.match(/[\d.]+/)?.[0]);
        const badge=row.querySelector('.verified-badge');
        const verified=!!badge&&!badge.classList.contains('hidden')&&!badge.hidden;
        if (name&&text&&Number.isFinite(rating)&&rating>0&&rating<=5) records.set(name+'\n'+text,{name,text,rating,verified,row});
      }
      const values=[...records.values()];
      if (!values.length) return;
      const signature=JSON.stringify(values.map(({row,...record})=>record));
      if (signature===this.signature) return;
      this.signature=signature;
      const position=this.track.scrollLeft;
      const fragment=document.createDocumentFragment();
      for (const item of values) {
        const card=document.createElement('article');card.className='jrt__card';card.tabIndex=0;card.setAttribute('role','button');card.setAttribute('aria-label',this.dataset.read+' · '+item.name);
        const name=document.createElement('h3');name.textContent=item.name;
        const stars=document.createElement('div');stars.className='jrt__stars';stars.textContent='★'.repeat(Math.round(item.rating))+'☆'.repeat(5-Math.round(item.rating));stars.setAttribute('aria-label',item.rating+' / 5');
        const text=document.createElement('p');text.textContent=item.text;
        card.append(name,stars,text);
        if (item.verified || this.dataset.merchantVerified === 'true') {
          const footer=document.createElement('span');footer.className='jrt__verified';
          const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');icon.setAttribute('viewBox','0 0 24 24');icon.setAttribute('aria-hidden','true');
          const line=document.createElementNS('http://www.w3.org/2000/svg','path');line.setAttribute('d','m9 12 2 2 4-4M12 3l3 1 3 1 1 3 2 4-2 3-1 3-3 1-3 2-3-2-3-1-1-3-2-3 2-4 1-3 3-1Z');icon.append(line);
          footer.append(icon,document.createTextNode(item.verified ? this.dataset.verified : this.dataset.merchantLabel));card.append(footer);
        }
        const open=()=>item.row.click();
        card.addEventListener('click',open,{signal:this.abort.signal});
        card.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();open();}},{signal:this.abort.signal});
        fragment.append(card);
      }
      this.track.replaceChildren(fragment);this.track.scrollLeft=position;
      this.classList.add('is-ready');this.source.setAttribute('aria-hidden','true');this.navigation();
    }
    move(direction) {this.track.scrollBy({left:direction*((this.track.firstElementChild?.getBoundingClientRect().width||280)+16),behavior:this.motion()});}
    navigation() {this.prev.disabled=this.track.scrollLeft<3;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-3;}
    disconnectedCallback() {this.abort?.abort();this.abort=null;this.visibility?.disconnect();this.observer?.disconnect();this.shadow=null;clearTimeout(this.timer);cancelAnimationFrame(this.frame);}
  });
  const initMenu = () => {
    const panel=document.querySelector('[data-collections-menu]');
    if(!panel||panel.dataset.ready)return;panel.dataset.ready='true';
    let trigger=null,timer;
    const primary=element=>element?.closest('[data-joffz-header] [class*="header-menu-item-main-"]');
    const match=anchor=>anchor&&primary(anchor)&&!anchor.closest('[class*="header-submenu-"]')&&/\/collections\/?$/.test(new URL(anchor.href,location.href).pathname);
    const close=()=>{if(panel.matches(':popover-open'))panel.hidePopover();trigger?.setAttribute('aria-expanded','false');};
    const open=anchor=>{
      if(!match(anchor))return;
      clearTimeout(timer);trigger=anchor;
      const header=anchor.closest('[data-joffz-header]');
      header.dispatchEvent(new CustomEvent('joffz:navigation-reset'));
      panel.style.setProperty('--jcm-top',Math.max(0,Math.min(innerHeight*.6,header.getBoundingClientRect().bottom))+'px');
      anchor.setAttribute('aria-haspopup','dialog');anchor.setAttribute('aria-controls',panel.id);anchor.setAttribute('aria-expanded','true');
      if(!panel.matches(':popover-open'))panel.showPopover();
    };
    document.addEventListener('click',event=>{
      const anchor=event.target.closest('a[href]');if(!match(anchor)||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
      event.preventDefault();event.stopImmediatePropagation();
      open(anchor);
    },true);
    document.addEventListener('pointerover',event=>{
      if(event.pointerType!=='mouse'||!matchMedia('(min-width:1024px)').matches)return;
      const anchor=event.target.closest('a[href]');if(match(anchor))open(anchor);
      else if(!panel.contains(event.target) && primary(event.target) && primary(event.target)!==primary(trigger) && event.target.closest('a,button')){close();if(!primary(event.target).querySelector('.joffz-nav-trigger'))event.target.closest('[data-joffz-header]').dispatchEvent(new CustomEvent('joffz:navigation-reset'));}
    });
    document.addEventListener('focusin',event=>{const anchor=event.target.closest('a[href]');if(match(anchor)&&matchMedia('(min-width:1024px)').matches)open(anchor);else if(!panel.contains(event.target)&&primary(event.target)!==primary(trigger)&&primary(event.target))close();});
    document.addEventListener('joffz:navigation-open',()=>{if(!panel.matches(':hover')&&!trigger?.matches(':hover'))close();});
    document.addEventListener('pointermove',event=>{
      if(event.pointerType!=='mouse'||!panel.matches(':popover-open'))return;
      const header=trigger?.closest('[data-joffz-header]');
      clearTimeout(timer);
      // The full header forms a pointer bridge between the trigger and top-layer panel.
      if(panel.contains(event.target)||header?.contains(event.target))return;
      timer=setTimeout(()=>{if(!panel.matches(':hover')&&!panel.contains(document.activeElement))close();},350);
    });
    panel.addEventListener('pointerenter',()=>clearTimeout(timer));
    panel.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse')timer=setTimeout(()=>{if(!panel.contains(document.activeElement))close();},350);});
    panel.addEventListener('toggle',()=>{if(!panel.matches(':popover-open'))trigger?.setAttribute('aria-expanded','false');});
    document.addEventListener('keydown',event=>{if(event.key==='Escape')close();});
  };
  initMenu();document.addEventListener('shopify:section:load',initMenu);
})();
